"use client";
import {
  useCompositeContainer
} from "../__chunks/42UBRT4A.js";
import {
  useToolbarItem
} from "../__chunks/FGSEH62K.js";
import "../__chunks/3CCTMYB6.js";
import "../__chunks/PLQDTVXM.js";
import "../__chunks/NAXN2XAB.js";
import "../__chunks/5VQZOHHZ.js";
import {
  useToolbarContext
} from "../__chunks/IIER4YBF.js";
import "../__chunks/WENSINUV.js";
import "../__chunks/FMYQNSCK.js";
import "../__chunks/HGZKAGPL.js";
import "../__chunks/SWN3JYXT.js";
import {
  createElement,
  createHook,
  forwardRef,
  memo
} from "../__chunks/HKOOKEDE.js";
import "../__chunks/2GXGCHW6.js";
import "../__chunks/Z32BISHQ.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/toolbar/toolbar-container.tsx
var TagName = "div";
var useToolbarContainer = createHook(
  function useToolbarContainer2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useToolbarContext();
    store = store || context;
    props = useCompositeContainer(__spreadValues({ store }, props));
    props = useToolbarItem(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarContainer = memo(
  forwardRef(function ToolbarContainer2(props) {
    const htmlProps = useToolbarContainer(props);
    return createElement(TagName, htmlProps);
  })
);
export {
  ToolbarContainer,
  useToolbarContainer
};
